import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"
import { EnforcementBadgeFragment } from "@/components/trustandsafety/EnforcementBadge"
import { bestItemOfferFragment } from "@/lib/fragments/best-order"
import { ItemCardMediaFragment } from "../../card/ItemCardMedia/ItemCardMedia.fragment"
import { ItemCardNameFragment } from "../../card/ItemCardName"
import { QuantityBadgeFragment } from "../../card/QuantityBadge"
import { RarityBadgeFragment } from "../../card/RarityBadge"
import { CollectionLinkFragment } from "../../collection/CollectionLink.fragment"
import { ItemLinkFragment } from "../../ItemLink"
import { OwnedQuantityFragment } from "../../OwnedQuantityBadge"
import { useAcceptOffersFragment } from "../../use-accept-offers.fragment"
import { useBuyItemsFragment } from "../../use-buy-items.fragment"
import { useCancelItemsListingsFragment } from "../../use-cancel-items-listings.fragment"
import { useCancelOrdersFragment } from "../../use-cancel-orders.fragment"
import { useListItemsFragment } from "../../use-list-items.fragment"
import { useMakeOfferFragment } from "../../use-make-offer.fragment"
import { ItemOwnedQuantityFragment } from "../../utils"
import { isItemTradableFragment } from "../../validation/tradable"
import { profileItemsSelectionFragment } from "../profile-items-selection-store"

export const ProfileItemsCardFragment = graphql(
  `
    fragment ProfileItemsCardFragment on Item {
      id
      isFungible
      chain {
        identifier
      }
      contractAddress
      tokenId
      ...bestItemOffer
      lowestListingForOwner(address: $address) {
        id
        pricePerItem {
          ...TokenPrice
        }
        maker {
          address
        }
        marketplace {
          identifier
        }
        ...useCancelOrders
      }
      owner {
        address
      }
      enforcement {
        isDisabled
        isCompromised
      }
      collection {
        slug
        ...CollectionLockup
        ...CollectionLink
        ...CollectionPreviewTooltip
      }
      ...useBuyItems
      ...useMakeOffer
      ...useListItems
      ...profileItemsSelection
      ...useAcceptOffers
      ...QuantityBadge
      ...ItemCardMedia
      ...ItemCardNameFragment
      ...RarityBadgeFragment
      ...ItemLink
      ...OwnedQuantity
      ...EnforcementBadge
      ...useCancelItemsListings
      ...ItemOwnedQuantity
      ...isItemTradable
    }
  `,
  [
    CollectionLockupFragment,
    ItemLinkFragment,
    ItemCardMediaFragment,
    ItemCardNameFragment,
    RarityBadgeFragment,
    TokenPriceFragment,
    useBuyItemsFragment,
    useMakeOfferFragment,
    profileItemsSelectionFragment,
    useListItemsFragment,
    useAcceptOffersFragment,
    OwnedQuantityFragment,
    EnforcementBadgeFragment,
    QuantityBadgeFragment,
    CollectionLinkFragment,
    useCancelItemsListingsFragment,
    useCancelOrdersFragment,
    bestItemOfferFragment,
    ItemOwnedQuantityFragment,
    CollectionPreviewTooltipFragment,
    isItemTradableFragment,
  ],
)
